module.exports = __webpack_public_path__ + "media/icons/heart-full-1428a519f0a3544de74b37c5ac8d9536.svg";